import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42df3e0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full px-4 my-3" }
const _hoisted_2 = { class: "text-sm" }
const _hoisted_3 = {
  key: 0,
  class: "material-icons pr-2 h-full my-auto w-12",
  style: {"padding-left":"14px"}
}
const _hoisted_4 = {
  key: 1,
  class: "material-icons pr-2 h-full my-auto w-12",
  style: {"padding-left":"14px"}
}
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = {
  key: 0,
  class: "border shadow-md flex justify-center items-center border-primary-50 dark:border-dark-400",
  style: {"height":"120px","border-bottom-left-radius":"0.5rem","border-bottom-right-radius":"0.5rem"}
}
const _hoisted_7 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex cursor-pointer", {
          'bg-primary-400 hover:bg-primary-300 text-white dark:bg-dark-400 dark:hover:bg-dark-300 rounded-top dark:text-dark-text':
            _ctx.isSummaryExpanded,
          'rounded-all hover:bg-gray-100 dark:hover:bg-dark-500': !_ctx.isSummaryExpanded
        }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
      }, [
        (_ctx.isSummaryExpanded)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " arrow_drop_up "))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, " arrow_drop_down ")),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "labels", {}, undefined, true)
        ])
      ], 2),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_LoadingPanel)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass({
          'rounded-bottom border shadow-md border-primary-50 dark:border-dark-400': _ctx.isSummaryExpanded
        })
      }, [
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "body", {}, undefined, true)
              ])
            ], 512), [
              [_vShow, _ctx.isSummaryExpanded]
            ])
          ]),
          _: 3
        })
      ], 2), [
        [_vShow, !_ctx.loading]
      ])
    ])
  ]))
}